/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IWalletSlice {
  walletData: any;
  isWalletDataLoading: boolean;
  refetchGetWallet: boolean;
}

const initialState: IWalletSlice = {
  walletData: null,
  isWalletDataLoading: false,
  refetchGetWallet: false
};

export const walletSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    setWalletData: (state: IWalletSlice, action: PayloadAction<any>) => {
      const { payload } = action;
      state.walletData = payload;
    },
    setIsWalletDataLoading: (state: IWalletSlice, action: PayloadAction<boolean>) => {
      const { payload } = action;
      state.isWalletDataLoading = payload;
    },
    setRefetchGetWallet: (state: IWalletSlice, action: PayloadAction<boolean>) => {
      const { payload } = action;
      state.refetchGetWallet = payload;
    }
  }
});

const { actions, reducer } = walletSlice;

export const { setWalletData, setIsWalletDataLoading, setRefetchGetWallet } = actions;

export default reducer;
